export default __webpack_public_path__ + "1db2f0ac0fce2ff2e8f46b3f0b2496f0.svg";